import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Formik } from 'formik';
import { RepliconDialog } from '~/modules/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';
import SetResourceAllocationDialogTitle from './SetResourceAllocationDialogTitle';
import SetResourceAllocationDialogContent from './SetResourceAllocationDialogContent';
import SetResourceAllocationDialogFooter from './SetResourceAllocationDialogFooter';
import SetResourceAllocationDialogLoadingState from './SetResourceAllocationDialogLoadingState';
import { useSetResourceAllocationFormState } from './hooks/useSetResourceAllocationFormState';

const SetResourceAllocationDialogTitleId =
  'set-resource-allocation-dialog-title';

const SetResourceAllocationDialog = ({
  existingResourceAllocation,
  onClose,
  onUpdateResourceAllocation,
  open,
  project,
  scale,
  user
}) => {
  const {
    initialValues,
    validationSchema,
    totalScheduledHours,
    isScheduleLoading,
    onSubmit
  } = useSetResourceAllocationFormState({
    existingResourceAllocation,
    project,
    scale,
    userUri: user?.id,
    onClose,
    onUpdateResourceAllocation
  });
  const [isFormDirty, setIsFormDirty] = useState(false);

  const checkIsDirty = useCallback(() => isFormDirty, [isFormDirty]);

  return (
    <RepliconDialog
      aria-labelledby={SetResourceAllocationDialogTitleId}
      checkIsDirty={checkIsDirty}
      data-qe-id="SetResourceAllocationDialog"
      enableUnsavedChangesWarning
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      trapFocusWithDatePicker
    >
      <SetResourceAllocationDialogTitle
        project={project}
        titleId={SetResourceAllocationDialogTitleId}
        user={user}
      />
      {isScheduleLoading ? (
        <SetResourceAllocationDialogLoadingState onClose={onClose} />
      ) : (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <>
            <SetResourceAllocationDialogContent
              setIsFormDirty={setIsFormDirty}
              totalScheduledHours={totalScheduledHours}
              user={user}
            />
            <SetResourceAllocationDialogFooter onClose={onClose} />
          </>
        </Formik>
      )}
    </RepliconDialog>
  );
};

SetResourceAllocationDialog.propTypes = {
  existingResourceAllocation: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onUpdateResourceAllocation: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)).isRequired,
  user: PropTypes.object
};

export default SetResourceAllocationDialog;
